export default __webpack_public_path__ + "static/media/pexels-vanessa-garcia-6325973 1.e369ba8c.png";